<template>
  <transition name="modal">
  <div class="settings-modal">
    <div class="settings-modal__wrapper modal-container" v-on-clickaway="cancelStatuses">
      <div class="settings-modal__header">
        <h1 class="settings-modal__title">{{ $tr('analytics.widgets.funnel.chooseStatus') }}</h1>
        <div class="settings-modal__status settings-modal__status_all">
          <vchecklabel 
            v-model="isSelectedAll"
            :label="$tr('analytics.widgets.funnel.selectAll')"/>
        </div>
      </div>

      <div class="settings-modal__content">
        <div class="settings-modal__status" v-for="status in allStatuses" :key="status.id">
          <vcheckbox
            v-model="status.selected"
            @input="checkedStatus(status)"/>
          <div class="settings-modal__status-name">{{status.name}}</div>
        </div>
      </div>

      <div class="settings-modal__footer">
        <vbutton
          label="common.save"
          @click="saveStatuses" />
        <vbutton
          label="common.cancel"
          color="transparent"
          @click="cancelStatuses" />
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'settings-modal',

  mixins: [
    clickaway
  ],

  props: ['allStatuses', 'selectedList'],

  computed: {
    isSelectedAll: {
      get () {
        if (!this.selectedList.length) {
          return false;
        }
        return this.$store.getters['analytics/funnel/isSelectedAll'];
      },

      set (val) {
        this.$store.commit('analytics/funnel/selectAll', val);
      }
    },
  },

  methods: {
    saveStatuses() {
      this.$store.dispatch('analytics/funnel/updateStatuses', this.allStatuses)
        .then(() => {
          this.$emit('saveStatuses');
        })
    },

    cancelStatuses() {
      this.$emit('cancelStatuses');
    },

    checkedStatus(status) {
      this.$store.commit('analytics/funnel/select', status);
    }
  }
}
</script>

<style lang="scss" scoped>
  .settings-modal {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 9998;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: opacity .3s ease;

    &__wrapper {
      width: 498px;
      max-height: 643px;
      background: #fff;
      box-shadow: 0 1px 40px rgba(0, 0, 0, 0.15);
      padding: 36px 13px 36px 31px;
      border-radius: 0;
      margin: 0;
      transition: all .3s ease;
    }

    &__title {
      font-size: 22px;
      line-height: 32px;
      color: #233346;
      font-weight: 500 !important;
      margin-bottom: 26px !important;
    }

    &__content {
      height: 400px;
      overflow-y: scroll;
    }

    &__status {
      display: flex;
      align-items: center;
      padding-bottom: 19px;

      &_all {
        padding-bottom: 23px;
      }

      &-name {
        margin-left: 10px;
      }
    }

    &__footer {
      padding-top: 31px;

      .green {
        margin-right: 12px;
      }
    }
  }
</style>